import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import * as React from 'react';
import { FlexBox } from '../box';
import { IconButton } from '../button';
import { Tooltip } from '../tooltip';
import { Typography } from '../typography';
import { withVersion } from '../utils';
export function maskEmail(email) {
    const atIndex = email.indexOf('@');
    if (atIndex === -1) {
        return email;
    }
    const local = email.slice(0, atIndex);
    const domain = email.slice(atIndex + 1);
    if (local.length === 0) {
        return email;
    }
    if (local.length === 1) {
        return `*@${domain}`;
    }
    if (local.length === 2) {
        return `**@${domain}`;
    }
    return `${local[0]}${'*'.repeat(local.length - 2)}${local[local.length - 1]}@${domain}`;
}
const MaskedEmailInner = ({ email, canReveal = false, showTooltip = 'Show email', hideTooltip = 'Hide email', hiddenTooltip = 'Email address hidden', className, 'data-role': dataRole = 'masked-email', 'data-role-value': dataRoleValue }) => {
    const [revealed, setRevealed] = React.useState(false);
    const isRevealed = canReveal && revealed;
    const displayText = isRevealed ? email : maskEmail(email);
    if (!canReveal) {
        return (_jsx(Tooltip, { title: hiddenTooltip, placement: "top", children: _jsx(Typography, { component: "span", className: className, "data-role": dataRole, "data-role-value": dataRoleValue, children: displayText }) }));
    }
    return (_jsxs(FlexBox, { alignItems: "center", gap: 0.25, display: "inline-flex", className: className, "data-role": dataRole, "data-role-value": dataRoleValue, children: [_jsx(Typography, { component: "span", children: displayText }), _jsx(Tooltip, { title: isRevealed ? hideTooltip : showTooltip, placement: "top", children: _jsx(IconButton, { icon: isRevealed ? 'IconVisibilityOff' : 'IconVisibility', size: "small", onClick: () => setRevealed((v) => !v), "aria-label": isRevealed ? hideTooltip : showTooltip, "aria-pressed": isRevealed, "data-role": "masked-email-toggle" }) })] }));
};
const MaskedEmailImpl = (props) => (_jsx(MaskedEmailInner, { ...props }, props.email));
MaskedEmailImpl.displayName = 'MaskedEmail';
export const MaskedEmail = withVersion(MaskedEmailImpl, '1.0.0');
